export const DIALOG_MOBILE_SIZE = 510;
export const DIALOG_ASK_URL = 'Enter the URL of the link:';
export const DIALOG_ASK_TEXT = 'Enter the TEXT of the link:';
